<div class="my-3 d-none d-lg-block position-relative">
  <ng-content select="[leaderboard-large]"></ng-content>
</div>
<div class="my-3 d-none d-md-block d-lg-none position-relative">
  <ng-content select="[leaderboard-small]"></ng-content>
</div>
<main class="container bg-white color-900 min-vh-100">
  <div class="row">
    <div class="col-12 col-lg-8 pt-0 pt-sm-2 content-container">
      <div class="header-container">
        <ng-content select="[header]"></ng-content>
      </div>
      <div class="mt-4 mb-3 mb-md-4 pt-2 position-relative d-block tab-container">
        <ng-content select="[tabs]" class="tabs"></ng-content>
      </div>
      <div class="w-100" style="min-height: 480px">
        <router-outlet></router-outlet>
      </div>
      <div class="text-center d-block d-lg-none mb-3 mobile-ad-container">
        <div class="d-flex justify-content-center">
          <ng-content select="[mobile-ad]"></ng-content>
        </div>
      </div>
    </div>
    <div
      class="sidebar d-lg-block col-12 col-lg-4 border-start pt-sm-2 px-lg-0 px-3"
    >
      <div class="d-none d-lg-flex justify-content-center pt-4 py-3">
        <ng-content select="[sidebar-ad]"></ng-content>
      </div>
      <ng-content select="[sidebar]"></ng-content>
      <div class="d-none d-lg-flex stick-to-header justify-content-center pt-4 py-3">
        <ng-content select="[sidebar-ad-sticky]"></ng-content>
      </div>
      <ng-content select="[sidebar-description]"></ng-content>
    </div>
  </div>
</main>
<div
  class="bg-white color-900 d-md-none pt-1 stick-to-footer"
>
  <ng-content select="[footer]"></ng-content>
</div>
